<template>
    <div class="grid-item grid-item-half">
        <template v-if="overpaymentTransaction">
            <h3>Overpayment</h3>
            <table class="table table-compact">
                <tbody>
                <tr>
                    <th class="width-half">Transaction</th>
                    <th class="text-right">Amount</th>
                </tr>
                <tr :key="overpaymentTransaction.id">
                    <td class="width-half">
                        <router-link :to="{name: 'transaction-details', params: {id: overpaymentTransaction.id}}">
                            {{overpaymentTransaction.explanation}}
                        </router-link>
                    </td>
                    <td class="text-right is-numeric">
                        {{creditMemo.totalCredit | monetize(creditMemo.currency)}}
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
        <template v-if="refundTransactions.length > 0">
            <h3>Refunds</h3>
            <table class="table table-compact">
                <tbody>
                <tr>
                    <th class="width-half">Transaction</th>
                    <th class="text-right">Amount</th>
                </tr>
                <tr v-for="transaction in refundTransactions" :key="transaction.id">
                    <td class="width-half">
                        <router-link :to="{name: 'transaction-details', params: {id: transaction.id}}">
                            {{transaction.explanation}}
                        </router-link>
                    </td>
                    <td class="text-right is-numeric">
                        {{creditMemo.getTotalRefundTransactionAmount(transaction.id) | monetize(transaction.currency)}}
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
        <template v-if="reversalTransactions.length > 0">
            <h3>Reversals</h3>
            <table class="table table-compact">
                <tbody>
                <tr>
                    <th class="width-half">Transaction</th>
                    <th class="text-right">Amount</th>
                </tr>
                <tr v-for="transaction in reversalTransactions" :key="transaction.id">
                    <td class="width-half">
                        <router-link :to="{name: 'transaction-details', params: {id: transaction.id}}">
                            {{transaction.explanation}}
                        </router-link>
                    </td>
                    <td class="text-right is-numeric">
                        {{creditMemo.getTotalReversalTransactionAmount(transaction.id) | monetize(transaction.currency)}}
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapState('creditMemos', [
                'creditMemo',
            ]),
            ...mapGetters('creditMemos', [
                'overpaymentTransaction',
                'refundTransactions',
                'reversalTransactions',
            ]),
        },
    };
</script>
